import { Button, Checkbox, Container, Divider, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, Link, List, ListItem, makeStyles, TextField, Typography } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers"
import axios from "axios"
import Axios from "axios"
import moment from "moment"
import React, { useCallback, useEffect, useRef, useState } from "react"
import DateFnsUtils from '@date-io/date-fns'
import { da } from 'date-fns/locale';
import { FC } from "react"
import { Column } from "react-table"
import * as StatsModels from '../../api/statistics/models'
import NoDataDialog from "../../components/dialogs/ErrorDialog"
import SaveDialog from "../../components/dialogs/SaveDialog"
import DividerWithText from "../../components/layout/dividerwithtext"
import Table from "../../components/Table"
import { trAmount, trDate } from "../../utils/tr"
import { ConventionArea, ConventionPeriod, CraftmanArea, CraftmanPeriod, DispensionArea, DispensionPeriod, LicenseType, LivingArea, LivingPeriod, ParkArea, ParkCommuneArea, ParkPeriod } from "./digitalLicensDataTemplates"
import LoadingSymbols from "../../utils/loadingSymbol"
import ConfirmDialogOptionalColor from "../../components/dialogs/ConfirmDialogOptionalColor"
import ErrorDialog from "../../components/dialogs/ErrorDialog"
import InfoDialog from "../../components/dialogs/InfoDialog"
import StatusDividerWithText from "../../components/layout/statusdivider"
import { getConventionAreas, getCraftmanArea, getDispensionAreas, getLivingAreas, getParkAreas, renderPeriodDayType } from "../../utils/digitallicensContext"
import CertificateDialog from "../../components/dialogs/CertificateDialog"
import DigitalLicensTable from "../../components/Table/DigitalLicensTable"

const useStyles = makeStyles((theme) => ({
    paper: {
        [theme.breakpoints.up('sm')]: {
            padding: '0',
        },
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    
    autoCompleteClass: {  
        minWidth: "200px", 
    },

    buts: {
        width: '100%',
        height: '100%'
    },
    grid: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    textHelp: {
        marginBottom: '1rem'
    },
    margTop: {
        marginTop: theme.spacing(2),
    },

    areaColorOptions: {
        // Hover
     //with light-grey
        '&[data-focus="true"]': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
          borderColor: 'transparent',
        },
        // Selected
     //has dark-grey
        '&[aria-selected="true"]': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          borderColor: 'transparent',
        },
      },
    
}))

const DigitalLicens: FC = () => {
    const classes = useStyles()

     // DigitalLicens helpers
    const [licenseType] = useState(LicenseType)
    const [parkPeriod] = useState(ParkPeriod)
    const [parkArea] = useState(ParkArea)
    const [parkCommuneArea] = useState(ParkCommuneArea)
    const [livingPeriod] = useState(LivingPeriod)
    const [livingArea] = useState(LivingArea)
    const [craftmanPeriod] = useState(CraftmanPeriod)
    const [craftmanArea] = useState(CraftmanArea)
    const [dispensionPeriod] = useState(DispensionPeriod)
    const [dispensionArea] = useState(DispensionArea)
    const [conventionPeriod] = useState(ConventionPeriod)
    const [conventionArea] = useState(ConventionArea)

    // form helpers
    const [showNoDataDialog, setShowNoDataDialog] = React.useState(false)
    const [editLicensOpen, setEditLicensOpen] = useState(false)
    const [editLicensDialogStatusString, setEditLicensDialogStatusString] = useState("")
    const [licensDialogTitle, setLicensDialogTitle] = useState(Number)

    // checkboxed
    const [monday, setMonday] = useState(false)
    const [tuesday, setTuesday] = useState(false)
    const [wednesday, setWednesday] = useState(false)
    const [thursday, setThursday] = useState(false)
    const [friday, setFriday] = useState(false)
    const [saturday, setSaturday] = useState(false)
    const [sunday, setSunday] = useState(false)
    const [other, setOther] = useState(false)

    // HTML
    const [periodeInformation, setPeriodeInformation] = useState(<></>)

    // data from digital license
    const [parkantData, setParkantData] = useState<StatsModels.DigitalLicensesResponse>(new StatsModels.DigitalLicensesResponse())
    const [digitalLicensData, setDigitalLicensData] = useState([])
    const [licensType, setLicensType] = useState(-1)
    const [count, setCount] = useState(0)
    const [price, setPrice] = useState("")
    const [fromDate, setFromDate] = useState<Date | null>(new Date())
    const [name, setName] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [CVR, setCVR] = useState("")
    const [address, setAddress] = useState("")
    const [zipCode, setZipCode] = useState("")
    const [city, setCity] = useState("")
    const [email, setEmail] = useState("")
    const [phone, setPhone] = useState("")
    const [plate, setPlate] = useState("")
    const [note, setNote] = useState("")
    const [paymentDate, setPaymentDate] = useState<Date | null>()
    const [status, setStatus] = useState(0)
    
    const [noteToParkant, setNoteToParkant] = useState("")
    const [internalNote, setInternalNote] = useState("")

    const [chosenLicensType, setChosenLicensType] = useState("")

    // new methods for updateing the areas 
    const [autoAreaParking, setAutoAreaParking] = useState(parkCommuneArea) // ParkingArea
    const [autoAreaLiving, setAutoAreaLiving] = useState(livingArea)
    const [autoAreaCraftman, setAutoAreaCraftman] = useState(craftmanArea)
    const [autoAreaDispension, setAutoAreaDispension] = useState(dispensionArea)
    const [autoAreaEvent, setAutoAreaEvent] = useState(conventionArea) // conventionsAreas

    //continued updated period
    const [updatedPeriod, setUpdatedPeriod] = useState(0)
    // saved modified versions og digital licens data
    const [endtime, setEndTime] = useState("")
    
    const [oldArea, setOldArea] = useState("")
    const [oldCount, setOldCount] = useState(Number)
    const [oldLicensType, setOldLicensType] = useState(Number)
    const [oldPeriod, setOldPeriod] = useState(Number)
    const [oldPlate, setOldPlate] = useState("")
    const [oldStartDate, setOldStartDate] = useState<Date | null>(new Date())

    // certificate downloads
    const [fileNames, setFileNames] = useState([""])
    // confirm box
    const [confirmOpenMail, setConfirmOpenMail] = useState(false)
    const [confirmOpenText, setConfirmOpenText] = useState("")
    const [confirmStatus, setConfirmStatus] = useState(0)
    const [confirmColorGreen, setConfirmColorGreen] = useState(false)
    const [confirmType, setConfirmType] = useState(0)

    // Error BOX
    const [errorPopup, setErrorPopup] = useState(false)
    const [errorText, setErrorText] = useState("Noget gik galt, prøv venligst igen senere.")

    // cerfificate box
    const [cerfificatePopup, setCerfificatePopup] = useState(false)
    // Info box
    const [infoBoxOpen, setInfoBoxOpen] = useState(false)
    const [infoBoxText, setInfoBoxText] = useState("")
    const [infoBoxTitle, setInfoBoxTitle] = useState("")

    const [loadingSymbol, setLoadingSymbol] = useState(false)
    const labelLocationRef = useRef(null)

    // different endpoint urls are listed here
    const baseUrl = `${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/requests/` // Endpoint from "LicenseRequestController.cs"
    const urlDataDownload = `${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/requests` // Endpoint from "LicenseRequestController.cs"
    const urlReceipt = `${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/pdf/${licensDialogTitle}`
    const urlMailReceipt = `${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/receipt/${licensDialogTitle}`
    const urlPayment = `${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/sendpaymentlink/` // Endpoint from "LicenseRequestController.cs"

    useEffect(() => { // fetch data at page load
        licenseDataDownload()
    },[])

    useEffect(() => {
       setEditLicensDialogStatusString(renderStatus(oldLicensType, licensType, status, fromDate, count, updatedPeriod))
    }, [licensType, oldLicensType, status])

    useEffect(() => { // this updates the displayed endtime

        if (updatedPeriod === 0) {
            let targetDate = moment(fromDate)
            let endDate = targetDate.add(count, "days")
            endDate.subtract(1, "day")
            setEndTime(endDate.format("DD-MM-YYYY"))
          }
      
          else if (updatedPeriod === 1) {
            let targetDate = moment(fromDate)
            let endDate = targetDate.add(count, "weeks")
            endDate.subtract(1, "day")
            setEndTime(endDate.format("DD-MM-YYYY"))
          }
      
          else if (updatedPeriod === 2) {
            let targetDate = moment(fromDate)
            let endDate = targetDate.add(count, "months")
            endDate.subtract(1, "day")
            setEndTime(endDate.format("DD-MM-YYYY"))
          }
      
          else if (updatedPeriod === 3) {
            let targetDate = moment(fromDate)
            let endDate = targetDate.add(count, "years")
            endDate.subtract(1, "day")
            setEndTime(endDate.format("DD-MM-YYYY"))
          }
      
          else if (updatedPeriod === 4 && licensType !== 4) {
            let targetDate = moment(fromDate)
            let endDate = targetDate.add(count, "years")
            endDate.subtract(1, "day")
            setEndTime(endDate.format("DD-MM-YYYY"))
          }

    },[fromDate, updatedPeriod, count])

    function compareNumericString(rowA: any, rowB: any, id: any, desc: any) {
        let a = parseFloat(rowA.values[id].replace(".", ""))
        let b = parseFloat(rowB.values[id].replace(".", ""))

        if (rowA.values[0] === "Total") {  // find total row, and put it last or first
            a = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
        }
        if (rowB.values[0] === "Total") {
            b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
        }
        if (a > b) return 1; 
        if (a < b) return -1;
        return 0;
    }

    function compareDateString(rowA: any, rowB: any) {
        let a = rowA.original.emptyTime 
        let b = rowB.original.emptyTime

        if (a > b) return 1; 
        if (a < b) return -1;
        return 0;
    }

    function compareStatusString(rowA: any, rowB: any) { // sorts the status based on a custom wish from the client.
        let a = renderStatus(rowA.original.licenseType, rowA.original.modifiedLicenseType, rowA.original.status, rowA.original.startDate, rowA.original.count, rowA.original.period)
        let b = renderStatus(rowB.original.licenseType, rowB.original.modifiedLicenseType, rowB.original.status, rowB.original.startDate, rowB.original.count, rowB.original.period)
        let aSorter
        let bSorter

        // setting the a sorter value
        if (a === "Modtaget")
        {
            aSorter = 8
        } 
        else if(a === "Under behandling"){
            aSorter = 7
        }
        else if (a === "Afventer betaling"){
            aSorter = 6
        }
        else if (a === "Betalt"){
            aSorter = 5
        }
        else if (a === "Aktiv"){
            aSorter = 4
        }
        else if (a === "Udløbet"){
            aSorter = 3
        }
        else if(a === "Afvist"){
            aSorter = 2
        } 
        else if (a === "Annulleret"){
            aSorter = 1
        }
        else{
            aSorter = 0
        }

        // setting the b sorter value
        if (b === "Modtaget")
        {
            bSorter = 8
        }   
        else if(b === "Under behandling"){
            bSorter = 7
        }
        else if (b === "Afventer betaling"){
            bSorter = 6
        }
        else if (b === "Betalt"){
            bSorter = 5
        }
        else if (b === "Aktiv"){
            bSorter = 4
        }
        else if (b === "Udløbet"){
            bSorter = 3
        }
        else if(b === "Afvist"){
            bSorter = 2
        } 
        else if (b === "Annulleret"){
            bSorter = 1
        }
        else{
            bSorter = 0
        }   

        if (aSorter > bSorter) return 1; 
        if (aSorter < bSorter) return -1;
        return 0;
    }

    const renderType = (originalType: number, modifiedType: number) => {
        let switchType

        if (modifiedType !== null) {
            switchType = modifiedType
        }
        else{
            switchType = originalType
        }

        switch (switchType) {
            case 0: return "Parkeringstilladelser"  
            case 1: return "Beboer- og erhvervslicens" 
            case 2: return "Håndværkerlicens"  
            case 3: return "Dispensationer"  
            case 4: return "Landsstævnet 2022" 
        }
        return "?"
    }

    const renderStatus = (currentLicens: number, modCurrentLicens: number, statusType: number, licensFromDate: Date | null, amountOfDays: number, typeOfPeriod: number ) => {

        let licensCheck

        if(modCurrentLicens != null){
            licensCheck = currentLicens
        }
        else{
            licensCheck = modCurrentLicens
        }

        let processedStatus 
        let lastEventDay // becomes the enddate
        let momentLastDate
        let curMomentDate = moment(new Date())

        if (licensCheck === 4 ){
            if (isDaySet(ConventionDays.Monday, typeOfPeriod)){
                lastEventDay = new Date(2022, 5, 27)
            }
            if (isDaySet(ConventionDays.Tuesday, typeOfPeriod)){
                lastEventDay = new Date(2022, 5, 28)
            }
            if (isDaySet(ConventionDays.Wednesday, typeOfPeriod)){
                lastEventDay = new Date(2022, 5, 29)
            }
            if (isDaySet(ConventionDays.Thursday, typeOfPeriod)){
                lastEventDay = new Date(2022, 5, 30)
            }
            if (isDaySet(ConventionDays.Friday, typeOfPeriod)){
                lastEventDay = new Date(2022, 6, 1)
            }
            if (isDaySet(ConventionDays.Saturday, typeOfPeriod)){
                lastEventDay = new Date(2022, 6, 2)
            }
            if (isDaySet(ConventionDays.Sunday, typeOfPeriod)){
                lastEventDay = new Date(2022, 6, 3)
            }
            if (isDaySet(ConventionDays.Other, typeOfPeriod)){
                lastEventDay = new Date(2022, 6, 3)
            }

            momentLastDate = moment(lastEventDay)
        }
        else{
            const dayType = renderPeriodDayType(typeOfPeriod)
            var momentDate = moment(licensFromDate)
            momentDate = momentDate.add(amountOfDays, dayType)
            momentLastDate = momentDate
        }

        if (statusType === 4 && (moment(licensFromDate).isBefore(curMomentDate) && moment(momentLastDate).isAfter(curMomentDate)) ){ // checks if the status is active
            processedStatus = 7
        }
        else if (statusType === 4 && moment(curMomentDate).isAfter(momentLastDate) ) {
            processedStatus = 6
        }
        else{
            processedStatus = statusType
        }

        if (statusType === 3 && licensCheck === 4){
            
            if (moment(licensFromDate).isBefore(curMomentDate) && moment(momentLastDate).isAfter(curMomentDate)){
                processedStatus = 7
            }
            else{
                processedStatus = 4
            }
            
        }

        switch (processedStatus) {
            case 0: return "Modtaget"   // New status
            case 1: return "Under behandling" // processing
            case 2: return "Afvist" // Rejected
            case 3: return "Afventer betaling" // Waiting for payment
            case 4: return "Betalt" // Paid
            case 5: return "Annulleret" // canceled, 
            case 6: return "Udløbet" // Expired
            case 7: return "Aktiv" // licens is active
        }
        return "?"
    }

    const renderPeriod = (type: number) => {
        switch (type) {
            case 0: return " Dag(e)"
            case 1: return " Uge(er)"
            case 2: return " Måned(er)"
            case 3: return " År"
            case 4: return " Andet"
        }
        return "?"
    }

    const renderEndDate = (currentLicens: number, dateElem: Date, countElem: number, periodElem: number, modCurrentLicens: number, modDateElem: Date, modCountElem: number, modPeriodElem: number,) => {
        let licensCheck
        let dateCheck
        let countCheck
        let periodCheck

        if (modCurrentLicens !== null){
            licensCheck = modCurrentLicens
        }
        else{
            licensCheck = currentLicens
        }
        if(modDateElem !== null){
            dateCheck = modDateElem
        }
        else{
            dateCheck = dateElem
        }
        if(modCountElem !== null){
            countCheck = modCountElem
        }
        else{
            countCheck = countElem
        }
        if(modPeriodElem !== null){
            periodCheck = modPeriodElem
        }
        else{
            periodCheck = periodElem
        }

        if (licensCheck === 4 ){
            let lastEventDay
            if (isDaySet(ConventionDays.Monday, periodCheck)){
                lastEventDay = new Date(2022, 5, 27)
            }
            if (isDaySet(ConventionDays.Tuesday, periodCheck)){
                lastEventDay = new Date(2022, 5, 28)
            }
            if (isDaySet(ConventionDays.Wednesday, periodCheck)){
                lastEventDay = new Date(2022, 5, 29)
            }
            if (isDaySet(ConventionDays.Thursday, periodCheck)){
                lastEventDay = new Date(2022, 5, 30)
            }
            if (isDaySet(ConventionDays.Friday, periodCheck)){
                lastEventDay = new Date(2022, 6, 1)
            }
            if (isDaySet(ConventionDays.Saturday, periodCheck)){
                lastEventDay = new Date(2022, 6, 2)
            }
            if (isDaySet(ConventionDays.Sunday, periodCheck)){
                lastEventDay = new Date(2022, 6, 3)
            }
            if (isDaySet(ConventionDays.Other, periodCheck)){
                lastEventDay = new Date(2022, 6, 3)
            }
            var momentDate = moment(lastEventDay)
            return momentDate.format("DD-MM-YYYY")
        }
        else{
            const dayType = renderPeriodDayType(periodCheck)
            var momentDate = moment(dateCheck)
            momentDate = momentDate.add(countCheck, dayType)
            
            momentDate.subtract(1, "day")
            return momentDate.format("DD-MM-YYYY")
        }
    }

    function renderPlate(original: any, modified: any){
        if (modified !== null){
            return modified.split(",").join(", ") + " "
        }
        else{
            return original.split(",").join(", ") + " "
        }
    }

    function renderArea(originalArea: any, modifiedArea: any){
        if (modifiedArea !== null){
            return modifiedArea
        }
        else{
            return originalArea
        }
    }

    function renderStartDate(originalDate: any, modifiedDate: any){
        if (modifiedDate !== null){
            if (modifiedDate !== undefined){
                return trDate(new Date (modifiedDate)) + " kl.00:00"
            }
            else{
                return trDate(new Date (originalDate)) + " kl.00:00"
            }
        }
        else{
            return trDate(new Date (originalDate)) + " kl.00:00"
        }
    }

    function getFileNames(){
        setLoadingSymbol(true)
        let fileNameURL = `${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/certificateName/` // Endpoint from "LicenseRequestController.cs"
        axios({
            url: fileNameURL + licensDialogTitle.toString(),
            method: 'GET',
      }).then(({ data }) => {
          setFileNames(data)
          setLoadingSymbol(false)
    }).catch(err => (setLoadingSymbol(false), setErrorPopup(true), setErrorText("Noget gik galt, prøv venligst igen senere.")));
    }

    const getFile = (elem: string) => {
        setLoadingSymbol(true)
        let fileURL = `${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/certificate/` // Endpoint from "LicenseRequestController.cs"
        let elemExtension = elem.split('.').pop()?.toString();
        if (elemExtension === undefined){
            elemExtension = "pdf"
        }
        let fileName = elem.split(".") // Used to get the filename for naming the downloads
        axios({
            url: fileURL + licensDialogTitle.toString(), 
            method: 'GET',
            responseType: 'blob', 
            params: {requestedFile: elem}
      }).then(({ data }) => {
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', (fileName[0] + "." + elemExtension)); //extensions
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLoadingSymbol(false)
        })
       .catch(err => (setLoadingSymbol(false), setErrorPopup(true), setErrorText("Noget gik galt, prøv venligst igen senere.")));
    }

    const columnsDigitalLicens: Column<StatsModels.DigitalLicensesData>[] = React.useMemo(() => [
        {Header: "Ref. nr.", id: "0", accessor: "digitalLicenseRequestId"},
        {Header: "Licenstype", id: "1", accessor: a => renderType(a.licenseType, a.modifiedLicenseType)},
        {Header: "Område", id: "2", accessor: a => renderArea(a.area, a.modifiedArea)},
        {Header: "Start dato", id: "3", accessor: a => renderStartDate(a.startDate, a.modifiedStartDate), sortType: compareDateString},
        {Header: "Slut dato", id: "4", accessor: a => renderEndDate(a.licenseType, a.startDate, a.count, a.period, a.modifiedLicenseType, a.modifiedStartDate, a.modifiedCount, a.modifiedPeriod) + " kl. 24:00", sortType: compareDateString},
        {Header: "Navn ", id: "5", accessor: "name"},
        {Header: "Adresse", id: "6", accessor: "address"},
        {Header: "Firmanavn", id: "7", accessor: "companyName"},
        {Header: "Reg. nr.", id: "8", accessor: a => renderPlate(a.plate, a.modifiedPlate)},
        {Header: "Status", id: "9", accessor: a => renderStatus(a.licenseType, a.modifiedLicenseType, a.status, a.modifiedStartDate || a.startDate, a.modifiedCount || a.count, a.modifiedPeriod || a.period), sortType: compareStatusString},
    ], [])

    const handleRowClick = (element: StatsModels.DigitalLicensesData) => {
        setFileNames([""]) // resets files 
        setMonday(false)
        setTuesday(false)
        setWednesday(false)
        setThursday(false)
        setFriday(false)
        setSaturday(false)
        setSunday(false)
        setOther(false)
        // Data from database
        setLicensDialogTitle(element.digitalLicenseRequestId)

        if (element.modifiedLicenseType !== null)
        {
            setLicensType(element.modifiedLicenseType)
        }
        else
        {
            setLicensType(element.licenseType)
        }

        if (element.modifiedPeriod !== null)
        {
            setUpdatedPeriod(element.modifiedPeriod)
        }
        else
        {
            setUpdatedPeriod(element.period)
        }

        let tempLicensType

        if (element.modifiedLicenseType !== null){
            tempLicensType = element.modifiedLicenseType
        }
        else{
            tempLicensType = element.licenseType
        }

        if (tempLicensType === 0){
            if(element.modifiedArea !== null){
                let newArr = element.modifiedArea.split("; ")
                let newArea = getParkAreas(newArr)
                setAutoAreaParking(newArea)
            }
            else{
                let newArr = element.area.split("; ")
                let newArea = getParkAreas(newArr)
                setAutoAreaParking(newArea)
            }
        }

        if(tempLicensType === 1){ // Living case
            if(element.modifiedArea != null){
                let newArr = element.modifiedArea.replace(/ *\([^)]*\) */g, "").split("; ")
                let newArea = getLivingAreas(newArr)
                setAutoAreaLiving(newArea)
            }
            else{
                let newArr = element.area.replace(/ *\([^)]*\) */g, "").split("; ")
                let newArea = getLivingAreas(newArr)
                setAutoAreaLiving(newArea)
            }
        }

        if (tempLicensType === 2){ //Craftman case
            if(element.modifiedArea != null){
                let newArr = element.modifiedArea.split("; ")
                let newArea = getCraftmanArea(newArr)
                setAutoAreaCraftman(newArea)
            }
            else{
                let newArr = element.area.split("; ")
                let newArea = getCraftmanArea(newArr)
                setAutoAreaCraftman(newArea)
            }
        }

        if (tempLicensType === 3){ // dispension case
            if(element.modifiedArea != null){
                let newArr = element.modifiedArea.split("; ")
                if (newArr.includes("Kørselstilladelse Møllergade")){
                    newArr.splice(1,2)
                }
                let newArea = getDispensionAreas(newArr)
                setAutoAreaDispension(newArea)
            }
            else{
                let newArr = element.area.split("; ")
                if (newArr.includes("Kørselstilladelse Møllergade")){
                    newArr.splice(1,2)
                }
                let newArea = getDispensionAreas(newArr)
                setAutoAreaDispension(newArea)
            }
        }

        if (tempLicensType === 4) { // speciel event case
        if (element.modifiedArea != null)
        {
            let newArr = element.modifiedArea.split("; ")
            let newArea = getConventionAreas(newArr)
            setAutoAreaEvent(newArea)
        }
        else
        {
            let newArr = element.area.split("; ")
            let newArea = getConventionAreas(newArr)
            setAutoAreaEvent(newArea)
        }
    }

        setPrice(trAmount(element.price100 / 100))

        if(element.modifiedStartDate !== null){
            setFromDate(element.modifiedStartDate)
        }
        else{
            setFromDate(element.startDate)
        }

        setName(element.name)
        setCompanyName(element.companyName)
        setCVR(element.cvr)
        setAddress(element.address)
        setZipCode(element.zip)
        setCity(element.city)
        setEmail(element.email)
        setPhone(element.phone)

        if(element.modifiedPlate !== null){
            setPlate(element.modifiedPlate)
        }
        else{
            setPlate(element.plate)
        }

        setNote(element.note)

        if (element.modifiedCount !== null){
            setCount(element.modifiedCount)
        }
        else{
            setCount(element.count)
        }

        setStatus(element.status)
        setNoteToParkant(element.parkantNote)
        setInternalNote(element.internalNote)
        
        if (element.paymentDate !== null){
            setPaymentDate(element.paymentDate)
        }
        else {
            setPaymentDate(null)
        }

        setOldArea(element.area)
        setOldLicensType(element.licenseType)
        setOldPeriod(element.period)
        setOldStartDate(element.startDate)
        setOldCount(element.count)
        setOldPlate(element.plate)

        setEditLicensOpen(true)

        if (element.modifiedLicenseType !== null && element.modifiedLicenseType === 4) {
            if (element.modifiedPeriod !== null){
                CheckAllConventionDays(element.modifiedPeriod)
            }
            else{
                CheckAllConventionDays(element.period)
            }
        }
        if (element.licenseType === 4){
            if (element.modifiedPeriod !== null){
                CheckAllConventionDays(element.modifiedPeriod)
            }
            else{
                CheckAllConventionDays(element.period)
            }
        }
    }

    function sendConfirmOrDenialEmail (typeOfMail: number) {

        // new info
        let licenseInfo
        let periodInfo
        let plateInfo
        let areaInfo
        let dateInfo
        let countInfo
        // old info
        let oldLicenseInfo
        let oldPeriodInfo
        let oldPlateInfo
        let oldAreaInfo
        let oldDateInfo
        let oldCountInfo

        if (licensType !== oldLicensType){
            licenseInfo = licensType
            if (licenseInfo === undefined){
                licenseInfo = null
            }
            oldLicenseInfo = oldLicensType
        }
        else{
            licenseInfo = null
            oldLicenseInfo = licensType
        }

        if (plate !== oldPlate){
            plateInfo = plate.toUpperCase().replaceAll(",", ";").split(";").filter(function(str: any){return /\S/.test(str)}).join("; ")
            if (plateInfo.length === 0){
                plateInfo = null
            }
            oldPlateInfo = oldPlate.toUpperCase().replaceAll(",", ";").split(";").filter(function(str: any){return /\S/.test(str)}).join("; ")
        }
        else{
            plateInfo = null
            oldPlateInfo = plate.toUpperCase().split(", ").join("; ")
        }

        if (fromDate !== oldStartDate){ // needs to be fixed for other licenses
            dateInfo = fromDate
            if (dateInfo === undefined){
                dateInfo = null
            }
            oldDateInfo = oldStartDate
        }
        else{
            dateInfo = null
            oldDateInfo = fromDate
        }

        if (updatedPeriod !== oldPeriod){
            periodInfo = updatedPeriod
            if (periodInfo === undefined){
                periodInfo = null
            }
            oldPeriodInfo = oldPeriod
        }
        else{
            periodInfo = null
            oldPeriodInfo = updatedPeriod
        }
        
        if (count !== oldCount){
            countInfo = count
            if (countInfo === undefined){
                countInfo = null
            }
            oldCountInfo = oldCount
        }
        else {
            countInfo = null
            oldCountInfo = count
        }

        if (licensType === 0){
            if (oldArea !== autoAreaParking.map((a: any) => a.area).join("; ")){
                areaInfo = autoAreaParking.map((a: any) => a.area).join("; ")
                if (areaInfo.length === 0){
                    areaInfo = null
                }
                oldAreaInfo = oldArea
            }
            else{
                areaInfo = null
                oldAreaInfo = oldArea
            }
        }

        if (licensType === 1){
            if (oldArea !== autoAreaLiving.map((a: any) => a.area).join("; ")){
                areaInfo = autoAreaLiving.map((a: any) => a.area).join("; ")
                if (areaInfo.length === 0){
                    areaInfo = null
                }
                oldAreaInfo = oldArea
            }
            else{
                areaInfo = null
                oldAreaInfo = oldArea
            }
        }

        if (licensType === 2){
            if (oldArea !== autoAreaCraftman.map((a: any) => a.area).join("; ")){
                areaInfo = autoAreaCraftman.map((a: any) => a.area).join("; ")
                if (areaInfo.length === 0){
                    areaInfo = null
                }
                oldAreaInfo = oldArea
            }
            else{
                areaInfo = null
                oldAreaInfo = oldArea
            }
        }

        if (licensType === 3){
            if (oldArea !== autoAreaDispension.map((a: any) => a.area).join("; ")){
                areaInfo = autoAreaDispension.map((a: any) => a.area).join("; ")
                if (areaInfo.length === 0){
                    areaInfo = null
                }
                oldAreaInfo = oldArea
            }
            else{
                areaInfo = null
                oldAreaInfo = oldArea
            }
        }

        if (licensType === 4) {   
            if (oldArea !== autoAreaEvent.map((a: any) => a.area).join("; ") ){
                areaInfo = autoAreaEvent.map((a: any) => a.area).join("; ")
                if (areaInfo.length === 0){
                    areaInfo = null
                }
                oldAreaInfo = oldArea
            }
            else{
                areaInfo = null
                oldAreaInfo = oldArea
            }
        }

        let incommingStatus = typeOfMail
        setLoadingSymbol(true)
        
        if (status === 0 && incommingStatus === 1) {
            incommingStatus = 1
        }
        else if (incommingStatus === 1 && status > 1){
            incommingStatus = status
        }
        else if (incommingStatus === 10){
            incommingStatus = status
        }

        let userData = {
            LicenseType: oldLicenseInfo,
            Period: oldPeriodInfo,
            Count: oldCountInfo,
            StartDate: oldDateInfo,
            Area: oldAreaInfo,
            Address: address,
            Name: name,
            City: city,
            Zip: zipCode,
            Email: email,
            Phone: phone,
            Plate: oldPlateInfo,
            Note: note,
            CompanyName: companyName,
            Cvr: CVR,
            ParkantNote: noteToParkant,
            InternalNote: internalNote,

            ModifiedLicenseType: licenseInfo,
            ModifiedPeriod: periodInfo,
            ModifiedCount: countInfo,
            ModifiedStartDate: dateInfo,
            ModifiedArea: areaInfo,
            ModifiedPlate: plateInfo,
            Status: incommingStatus
        }

        axios.post(baseUrl + licensDialogTitle.toString(), userData )
        .then((res) => {
            setLoadingSymbol(false)
            if (incommingStatus === 1){ // Save command, dont close popup and update the status
                setStatus(1)
            }else{
            setEditLicensOpen(false)
            }
            setConfirmOpenMail(false)
            licenseDataDownload()
            if (typeOfMail === 10){
                axios.post(`${process.env.REACT_APP_MOBILBASE_API}/api/v1/digital_licenses/sendmail/${licensDialogTitle}`)
            .then((res) => {
                setInfoBoxTitle("Mail afsending")
                setInfoBoxText("Mail er blevet gensendt")
                setInfoBoxOpen(true)
            })
            .catch(err => (setErrorPopup(true), setErrorText("Noget gik galt, prøv venligst igen senere.")));
        }
        
        })
       .catch(err => (setLoadingSymbol(false), setErrorPopup(true), setErrorText("Noget gik galt, prøv venligst igen senere.")));
    }

    function downloadReceipt() {
        axios.get(urlReceipt,{
            responseType: 'blob'
            })
        .then((res) => {
            var blob = new Blob([res.data], { type: "application/pdf"})
            const blobUrl = URL.createObjectURL(blob)
            window.open(blobUrl)
        })
       .catch(err => (setErrorPopup(true), setErrorText("Noget gik galt, prøv venligst igen senere.")));
    }

    function downloadMailReceipt() {
        axios.get(urlMailReceipt,{
            responseType: 'blob'
            })
        .then((res) => {
            var blob = new Blob([res.data], { type: "application/pdf"})
            const blobUrl = URL.createObjectURL(blob)
            window.open(blobUrl)
        })
       .catch(err => (setErrorPopup(true), setErrorText("Noget gik galt, prøv venligst igen senere.")));
    }

    function licenseDataDownload (){
        Axios.get(urlDataDownload)
        .then((res) => {
            setDigitalLicensData(res.data)
        }).catch(err => setErrorPopup(true))
    }

    function resendEmail () { // this function resends a email with the current information
        sendConfirmOrDenialEmail(10)
    }

    function updateLicenseValue(val: any){ // the method that the current licenstype gets updated from the Autocomplete

        if (val !== null) {
            if (val.LicenseType === 1 || val.LicenseType === 2){ //check for living and craftman and set time to 1 year
                setCount(1)
                setUpdatedPeriod(3)
                if (val.LicenseType === 1){
                    setPrice("810.00")
                }
                else{
                    setPrice("414.00")
                }
            }
            else if (val.LicenseType === 0 || val.LicenseType === 3){ // check for parking and dispension and set time to one day
                setCount(1)
                setUpdatedPeriod(0)

                if (val.LicenseType === 0){
                    setPrice("84.00")
                }
                else{
                    setPrice("0.00")
                }
            }
            setEndTime("")
            setChosenLicensType(val?.type) // the licens name
            setLicensType(val?.LicenseType) // the licens number
        }
        
      }

   const dataFilter = useCallback((elementData: StatsModels.DigitalLicensesData[]) =>{

    return elementData
   },[])

   enum ConventionDays {
    Monday = 1 << 0, // 1
    Tuesday = 1 << 1, // 2
    Wednesday = 1 << 2, // 4
    Thursday = 1 << 3, // 8
    Friday = 1 << 4, // 16
    Saturday = 1 << 5, // 32
    Sunday = 1 << 6, // 64
    Other = 1 << 7, // 128
  }

  function isDaySet(day: ConventionDays, val: number) {
      return Boolean(day & val);
  }

   function updatePeriod(val: any){ // the method that the currentlocation gets updated from the Autocomplete
    if (val !== null) {

        if (licensType === 4) {
            setCount(1)
        }
        else{
            setCount(val?.periodTime)
        }

      setPrice(val?.price)
      setUpdatedPeriod(val?.periodType)
    }
  }

  function updateEdgeCaseDate( data: any){
    if (data !== null) {
        setCount(data.periodTime)
        setUpdatedPeriod(data.periodType)
    }
  }

  function updateParkingAreaValue(val: any){
      let stringArr = val.map((a: any) => a.area)
      let newArea = getParkAreas(stringArr)
      setAutoAreaParking(newArea)
  }

  function updateLivingAreaValue(val: any){
        let stringArr = val.map((a: any) => a.area)
        let newArea = getLivingAreas(stringArr)
        setAutoAreaLiving(newArea)
    }

    function updateCraftmanAreaValue(val: any){
        let stringArr = val.map((a: any) => a.area)
        let newArea = getCraftmanArea(stringArr)
        setAutoAreaCraftman(newArea)
    }

    function updateDispensionAreaValue(val: any){
        let stringArr = val.map((a: any) => a.area)
        let newArea = getDispensionAreas(stringArr)
        setAutoAreaDispension(newArea)
    }

    function updateConventionAreaValue(val: any){ // the method that the currentlocation gets updated from the Autocomplete
        let stringArr = val.map((a: any) => a.area)
        let newArea = getConventionAreas(stringArr)
        setAutoAreaEvent(newArea)
    }

    const handleDateChange = (newDate: any) => {
        setFromDate(newDate)
    }

  useEffect(() => {

    let counter = []

    if (monday){
        counter.push(1)
    }
    if (tuesday){
        counter.push(2)
    }
    if (wednesday){
        counter.push(4)
    }
    if (thursday){
        counter.push(8)
    }
    if (friday){
        counter.push(16)
    }
    if (saturday){
        counter.push(32)
    }
    if (sunday){
        counter.push(64)
    }
    if (other){
        counter.push(128)
    }

    if (counter.length > 0){
        setUpdatedPeriod(counter.reduce((a: any, b: any) => a + b, 0))
    }
    
},[monday,tuesday,wednesday,thursday,friday,saturday,sunday,other])

   function CheckAllConventionDays(val: number) {
        //setUpdatedPeriod(val)

        if (isDaySet(ConventionDays.Monday, val)){
            setMonday(true)
        }
        if (isDaySet(ConventionDays.Tuesday, val)){
            setTuesday(true)
        }
        if (isDaySet(ConventionDays.Wednesday, val)){
            setWednesday(true)
        }
        if (isDaySet(ConventionDays.Thursday, val)){
            setThursday(true)
        }
        if (isDaySet(ConventionDays.Friday, val)){
            setFriday(true)
        }
        if (isDaySet(ConventionDays.Saturday, val)){
            setSaturday(true)
        }
        if (isDaySet(ConventionDays.Sunday, val)){
            setSunday(true)
        }
        if (isDaySet(ConventionDays.Other, val)){
            setOther(true)
        }
   }

   useEffect(() => {

    if (licensType === 0){
        setPeriodeInformation(<>
        <Grid item xs={6} sm={6} >
          <DatePicker autoOk={true} format="dd-MM-yyyy" cancelLabel="Afvis" okLabel="Accepter" color="primary" label="Fra dato" value={fromDate} onChange={(e:any) => handleDateChange(e)}  />
        </Grid>
        <Grid item xs={6} sm={6} >
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
          <Autocomplete id='parkAuto' className={classes.autoCompleteClass} key={chosenLicensType} 
          options={parkPeriod} getOptionLabel={(option: any) => option.period} 
          defaultValue={parkPeriod.find( v => v.periodType === updatedPeriod && v.periodTime === count)} 
          onChange={(event, value) => updatePeriod(value)} 
          renderInput={params => ( 
          <TextField {...params} label="Periode" variant="outlined" />  
          )}/>
        </FormControl> 
        </Grid>
        <Grid item xs ={6} sm={6}>
            Slut dato: {endtime}
        </Grid>
        <Grid item xs={12} sm={12}>
        <DividerWithText>Område</DividerWithText>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
          <Grid item sm={12} >
            <Autocomplete disableCloseOnSelect classes={{option: classes.areaColorOptions}} multiple={true} 
            options={parkCommuneArea} getOptionLabel={option => option.area} 
            value={parkCommuneArea.filter((elem, index) => autoAreaParking.find(DataId => index === DataId.id) )}
            renderInput={params => (<TextField {...params} 
            label={"Områder"} variant="outlined" fullWidth />)}
            onChange={(event, value) => updateParkingAreaValue(value)} />
          </Grid>
        </FormControl> 
      </Grid>
        </>)
    }

    else if (licensType === 1){
        setPeriodeInformation(<>
        <Grid item xs={6} sm={6}>
          <DatePicker autoOk={true} format="dd-MM-yyyy" cancelLabel="Afvis" okLabel="Accepter" color="primary" label="Fra dato" value={fromDate} onChange={(e:any) => handleDateChange(e)} />
        </Grid>
        <Grid item xs={6} sm={6}>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
          <Autocomplete id='livingAuto' className={classes.autoCompleteClass} key={chosenLicensType} 
          options={livingPeriod} getOptionLabel={option => option.period} 
          defaultValue={livingPeriod.find(v => v.periodType === updatedPeriod && v.periodTime === count)} 
          onChange={(event, value) => updatePeriod(value)} 
          renderInput={params => ( 
          <TextField {...params} label="Periode" variant="outlined" />  
          )}/>
        </FormControl> 
        </Grid>
        <Grid item xs ={6} sm={6}>
            Slut dato: {endtime}
        </Grid>
        <Grid item xs={12} sm={12}>
        <DividerWithText>Område</DividerWithText>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
          <Grid item sm={12} >
            <Autocomplete disableCloseOnSelect classes={{option: classes.areaColorOptions}} multiple={true} 
            options={livingArea} getOptionLabel={option => option.area} 
            value={livingArea.filter((elem, index) => autoAreaLiving.find(DataId => index == DataId.id) )}
                renderInput={params => (<TextField {...params} 
                    label={"Områder"} variant="outlined" fullWidth />)}
                onChange={(event, value) => updateLivingAreaValue(value)} />
          </Grid>
        </FormControl> 
      </Grid>
        </>)
    }
    else if (licensType === 2){
        setPeriodeInformation(<>
        <Grid item xs={6} sm={6}>
          <DatePicker autoOk={true} format="dd-MM-yyyy" cancelLabel="Afvis" okLabel="Accepter" color="primary" label="Fra dato" value={fromDate} onChange={(e:any) => handleDateChange(e)}  />
        </Grid>
        <Grid item xs={6} sm={6}>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
          <Autocomplete id="id" className={classes.autoCompleteClass} key={chosenLicensType} 
           options={craftmanPeriod} getOptionLabel={option => option.period} 
           defaultValue={craftmanPeriod.find( v => v.periodType === updatedPeriod && v.periodTime === count)}
           onChange={(event, value) => updatePeriod(value)} 
           renderInput={params => ( 
          <TextField {...params} label="Periode" variant="outlined" />  
          )}/>
        </FormControl> 
        </Grid>
        <Grid item xs ={6} sm={6}>
            Slut dato: {endtime}
        </Grid>
        <Grid item xs={12} sm={12}>
            <DividerWithText>Område</DividerWithText>
            <FormControl variant="outlined" fullWidth margin="normal">
              <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
              <Grid item sm={12} >
                <Autocomplete disableCloseOnSelect classes={{option: classes.areaColorOptions}} multiple={true}
                options={craftmanArea} getOptionLabel={option => option.area} 
                value={craftmanArea.filter((elem, index) => autoAreaCraftman.find(DataId => index == DataId.id) )}
                    renderInput={params => (
                    <TextField {...params} 
                        label={"Områder"} variant="outlined" fullWidth />)}
                        onChange={(event, value) => updateCraftmanAreaValue(value)} />
              </Grid>
            </FormControl> 
      </Grid>
        </>)
    }
    else if (licensType === 3){
        setPeriodeInformation(<>
            <Grid item xs={6} sm={6}>
          <DatePicker fullWidth autoOk={true}  format="dd-MM-yyyy"  cancelLabel="Afvis" okLabel="Accepter" color="primary" label="Fra dato" value={fromDate} onChange={(e:any) => handleDateChange(e)}  />
        </Grid>
        <Grid item xs={6} sm={6}>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
          <Autocomplete id="id" className={classes.autoCompleteClass} key={chosenLicensType} 
          options={dispensionPeriod} getOptionLabel={option => option.period} 
          defaultValue={dispensionPeriod.find( v => v.periodType === updatedPeriod && v.periodTime === count)} 
          onChange={(event, value) => updatePeriod(value)} 
          renderInput={params => ( 
          <TextField {...params} label="Periode" variant="outlined" />  
          )}/>
        </FormControl> 
        </Grid>
        <Grid item xs ={6} sm={6}>
            Slut dato: {endtime}
        </Grid>
        <Grid item xs={12} sm={12}>
            <DividerWithText>Område</DividerWithText>
            <FormControl variant="outlined" fullWidth margin="normal">
              <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
              <Grid item sm={12} >
                <Autocomplete disableCloseOnSelect classes={{option: classes.areaColorOptions}} multiple={true}  options={dispensionArea} getOptionLabel={option => option.area} 
                value={dispensionArea.filter((elem, index) => autoAreaDispension.find(DataId => index == DataId.id) )}
                    renderInput={params => (<TextField {...params} 
                        label={"Områder"} variant="outlined" fullWidth />)}
                    onChange={(event, value) => updateDispensionAreaValue(value)} />
              </Grid>
            </FormControl> 
      </Grid>
        </>)
    }
    else if (licensType === 4){
        setPeriodeInformation(<>
        <Grid item xs={6} sm={6}>
        <FormGroup>
            <FormControlLabel
                control={<Checkbox name="monday" id="monday" checked={monday} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setMonday(e.currentTarget.checked);}} />}
                label="Mandag d. 27. juni" />
            <FormControlLabel
                control={<Checkbox name="tuesday" id="tuesday" checked={tuesday} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setTuesday(e.currentTarget.checked);}} />}
                label="Tirsdag d. 28. juni" />
            <FormControlLabel
                control={<Checkbox name="wednesday" id="wednesday" checked={wednesday} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setWednesday(e.currentTarget.checked);}} />}
                label="Onsdag d. 29. juni" />
            <FormControlLabel
                control={<Checkbox name="thursday" id="thursday" checked={thursday} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setThursday(e.currentTarget.checked);}} />}
                label="Torsdag d. 30. juni" />
            <FormControlLabel
                control={<Checkbox name="friday" id="friday" checked={friday} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setFriday(e.currentTarget.checked);}} />}
                label="Fredag d. 1. juli" />
            <FormControlLabel
                control={<Checkbox name="saturday" id="saturday" checked={saturday} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setSaturday(e.currentTarget.checked);}} />}
                label="Lørdag d. 2. juli" />
            <FormControlLabel
                control={<Checkbox name="sunday" id="sunday" checked={sunday} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setSunday(e.currentTarget.checked);}} />}
                label="Søndag d. 3. juli" />
            <FormControlLabel
                control={<Checkbox name="other" id="other" checked={other} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setOther(e.currentTarget.checked);}} />}
                label="Andet - angiv i note" />
        </FormGroup>
        </Grid>
      <Grid item xs={12} sm={12}>
        <DividerWithText>Område</DividerWithText>
        <FormControl variant="outlined" fullWidth margin="normal">
          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
          <Grid item sm={12} >
            <Autocomplete disableCloseOnSelect classes={{option: classes.areaColorOptions}} multiple={true}  options={conventionArea} getOptionLabel={option => option.area} 
            value={conventionArea.filter((elem, index) => autoAreaEvent.find(DataId => index == DataId.id) )}
                renderInput={params => (<TextField {...params} 
                    label={"Kontrolposter"} variant="outlined" fullWidth />)}
                onChange={(event, value) => updateConventionAreaValue(value)} />
          </Grid>
        </FormControl> 
      </Grid>
        </>)
    }
    else{
        setPeriodeInformation(<></>)
    }

   },[licensType, updatedPeriod, monday, tuesday, wednesday, thursday, friday, autoAreaParking, autoAreaLiving, autoAreaCraftman, autoAreaDispension, autoAreaEvent, saturday, sunday, other, fromDate, endtime] )
    
   function confirmCloseSubmit() {

    if (status > 1){
    setConfirmStatus(10);
    setConfirmType(3); 
    setConfirmColorGreen(true); 
    setConfirmOpenText("Gem"); 
    setConfirmOpenMail(true);
    }
    else{
    setConfirmStatus(1);
    setConfirmType(2); 
    setConfirmColorGreen(true); 
    setConfirmOpenText("Gem"); 
    setConfirmOpenMail(true);
    }
    
   }
    return (
        <Container maxWidth={false}>
            <MuiPickersUtilsProvider locale={da} utils={DateFnsUtils}>
            <LoadingSymbols pendingLoadingPicture={loadingSymbol} setPendingLoadingPicture={loadingSymbol} open={loadingSymbol} loadingSymbolText={"Arbejder på anmodning"} />
            <ConfirmDialogOptionalColor open={confirmOpenMail} 
                onConfirmType={confirmType}
                onClose={() => setConfirmOpenMail(false)}
                onConfirm={() => sendConfirmOrDenialEmail(confirmStatus)}
                title={"Er du sikker på at du vil fuldføre handlingen?"}
                text={confirmOpenText} colorOfButtonGreen={confirmColorGreen} 
            />
            <ErrorDialog open={errorPopup} onClose={() => setErrorPopup(false) } title={"Fejl besked"} text={errorText} />
            <InfoDialog open={infoBoxOpen} onClose={() => setInfoBoxOpen(false) } title={infoBoxTitle} text={infoBoxText} />
            <CertificateDialog open={cerfificatePopup} onClose={() => 
                setCerfificatePopup(false) } 
                title={"Uploaded filer"} 
                text={fileNames.map((elem: any, index: number) => {
                    return (
                        <Grid item sm={12} style={{display: "flex", justifyContent: "right"}}>
                        <Link key={elem + index.toString()} onClick={() => getFile(elem)}>{elem}</Link>
                        </Grid>
                        )
                    })} >
            </CertificateDialog>
            <div className={classes.paper}>
            <Typography component="h1" variant="h5"> Ansøgninger </Typography>
                <div className={classes.grid}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <DigitalLicensTable<StatsModels.DigitalLicensesData> columns={columnsDigitalLicens} data={dataFilter(digitalLicensData)} initialState={{pageSize: 150, sortBy: [{ id: '9', desc: true }]}} clickEvent={handleRowClick} update={null} pending={false} text={""} columnFilter={true}/>
                        </Grid>
                    </Grid>
                </div>
            </div>

            <NoDataDialog open={showNoDataDialog} onClose={() => {setShowNoDataDialog(false)}} title={"Intet svar"} text={"Noget gik galt, prøv venligst igen senere."}/>

            <SaveDialog title={"Ref.nr.: " + licensDialogTitle.toString()} open={editLicensOpen} 
            currStatus={status}
            onCloseCancel={() => setEditLicensOpen(false)} 
            onCloseSubmit={() => confirmCloseSubmit() } 
            onReceipt={downloadReceipt}
            onMailReceipt={downloadMailReceipt}
            onSendConfimationEmail={() => (setConfirmStatus(3), setConfirmType(0), setConfirmColorGreen(true), setConfirmOpenText("Send til godkendelse og betaling"), setConfirmOpenMail(true)) } 
            onSendDenialEmail={() => (setConfirmStatus(2), setConfirmType(1), setConfirmColorGreen(false), setConfirmOpenText("Afvis ansøgning"), setConfirmOpenMail(true))}
            onResend={resendEmail}
            >
                <Grid container spacing={3} style={{padding: 8, paddingLeft: "20px", paddingRight: "20px"}}>
                    <Grid item xs={12} sm={12}>
                        <FormControl variant="outlined" fullWidth margin="normal">
                          <InputLabel ref={labelLocationRef} shrink htmlFor=""></InputLabel>
                          <Autocomplete id="licenseType" className={classes.autoCompleteClass} options={licenseType} getOptionLabel={option => option.type} defaultValue={licenseType.find( v => v.LicenseType === licensType)} onChange={(event, value) => updateLicenseValue(value)} 
                          renderInput={params => ( 
                          <TextField {...params} label="Licenstype" variant="outlined" />  
                          )}/>
                        </FormControl>     
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <DividerWithText>Periode</DividerWithText>
                    </Grid>
                    {periodeInformation}
                    <Grid item xs={12} sm={12}>
                        <Divider></Divider>
                    </Grid>
                    {/* The maxLength for the textfields are from the database "nvarchar" there are a small buffer to account for chars that are larger */}
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="name" name="name" inputProps={{ maxLength: 90}}  variant="outlined" fullWidth id="name" label="Navn" value={name} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setName(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="address" name="address" inputProps={{ maxLength: 90}}  variant="outlined" fullWidth id="address" label="Adresse" value={address} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setAddress(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="phone" name="phone" inputProps={{ maxLength: 45}}  variant="outlined" fullWidth id="phone" label="Mobil nr." value={phone} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setPhone(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="email" name="email" inputProps={{ maxLength: 90}}  variant="outlined" fullWidth id="email" label="Email" value={email} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setEmail(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="companyname" name="companyname" inputProps={{ maxLength: 90}}  variant="outlined" fullWidth id="companyname" label="Firmanavn" value={companyName} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setCompanyName(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="cvr" name="cvr" inputProps={{ maxLength: 18}}  variant="outlined" fullWidth id="cvr" label="CVR nr." value={CVR} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setCVR(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="city" name="city" inputProps={{ maxLength: 90}}  variant="outlined" fullWidth id="city" label="By" value={city} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setCity(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="zip" name="zip" inputProps={{ maxLength: 45}}  variant="outlined" fullWidth id="zip" label="Postnummer" value={zipCode} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setZipCode(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="reg nr." name="reg nr." inputProps={{ maxLength: 160}}  helperText="Del biler med ( , ) eller ( ; )" variant="outlined" fullWidth id="reg nr." label="Reg.nr." value={plate} autoFocus onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setPlate(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField autoComplete="price" name="price" helperText=" " variant="outlined" fullWidth InputProps={{readOnly: true}} id="price" label="Pris" value={price || ''} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setPrice(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField autoComplete="comment" name="comment" inputProps={{ maxLength: 1700}}  variant="outlined" fullWidth id="comment" label="Note fra ansøger" value={note} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setNote(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField autoComplete="commentParkant" name="commentParkant" inputProps={{ maxLength: 1700}}  variant="outlined" fullWidth id="commentParkant" label="Besked til ansøger" value={noteToParkant} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setNoteToParkant(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField autoComplete="internComment" rows={2} name="internComment" inputProps={{ maxLength: 1700}}  variant="outlined" fullWidth id="internComment" label="Intern note" value={internalNote} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setInternalNote(e.currentTarget.value);}} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <StatusDividerWithText>Status for ansøgning: {editLicensDialogStatusString}
                            <br />
                            {paymentDate
                            ?(<>Betalt: {trDate(new Date(paymentDate))}</>)
                            :(<></>)}
                        </StatusDividerWithText>
                    </Grid>
                    { (licensType === 1 || licensType === 2)
                    ?(<>
                    <Grid item xs={12} sm={12} style={{display: "flex", justifyContent: "right"}}>
                        <Button variant="contained" color="primary" onClick={() => (setCerfificatePopup(true), getFileNames())}>
                            Hent registreringsattester
                        </Button>
                    </Grid>
                </>):(<>

                    </>)}
                </Grid>
            </SaveDialog>
            <Typography>
                <b>Statusforklaring.</b>
                <List>
                    <ListItem>
                    <div><b>Modtaget </b>  -  <i> Ansøgningen er modtaget og afventer behandling.</i></div>
                    </ListItem>
                    <ListItem>
                    <div><b>Under behandling</b> - <i>Kommunen er i gang med behandlingen.</i></div>
                    </ListItem>
                    <ListItem>
                    <div><b>Afventer betaling</b> - <i>Ansøgningen er færdigbehandlet og afventer betaling.</i></div>
                    </ListItem>
                    <ListItem>
                    <div><b>Betalt</b> - <i>Licensen er betalt og aktiveres fra ønsket startdato.</i></div>
                    </ListItem>
                    <ListItem>
                    <div><b>Aktiv</b> - <i>Licensen er aktiveret og gyldig.</i></div>
                    </ListItem>
                    <ListItem>
                    <div><b>Udløbet</b> - <i>Gyldig licens er udløbet.</i></div>
                    </ListItem>
                    <ListItem>
                    <div><b>Afvist</b> - <i>Kommunen har afvist ansøgningen.</i></div>
                    </ListItem>
                    <ListItem>
                    <div><b>Annulleret</b> - <i>Ansøger har ikke betalt indenfor tidsfristen.</i></div>
                    </ListItem>
                </List>
            </Typography>
            </MuiPickersUtilsProvider>
        </Container>
    )
}

export default DigitalLicens